import { LayoutDashboard, BookOpen, Monitor, ClipboardCheck, MessageSquare, UserCircle } from 'lucide-react';
import type { Group } from '@/components/layout/GroupedLayout';
import type { NavItem } from '@/components/layout/RoleLayout';

/** Teacher menu, the same dropdown sections as the school owner's, in the order of a teaching week. */
export const teacherGroups: Group[] = [
  { key: 'overview', section: 'Overview', icon: LayoutDashboard, items: [{ to: 'dashboard', label: 'Dashboard' }] },
  { key: 'teaching', section: 'Teaching', icon: BookOpen, items: [
    { to: 'classes', label: 'My classes & students' },
    { to: 'timetable', label: 'Timetable' },
    { to: 'attendance', label: 'Class attendance' },
    { to: 'lessons', label: 'Lessons' },
    { to: 'live-classes', label: 'Live classes' },
    { to: 'assignments', label: 'Assignments & homework' },
  ] },
  { key: 'tests', section: 'Tests & CBT', icon: Monitor, items: [
    { to: 'question-banks', label: 'Question banks', also: ['question-bank'] },
    { to: 'cbt-exams', label: 'CBT tests', also: ['cbt-create', 'cbt-push', 'live-monitor', 'cbt-results'] },
  ] },
  { key: 'results', section: 'Scores & results', icon: ClipboardCheck, items: [
    { to: 'score-entry', label: 'Score entry' },
    { to: 'import-scores', label: 'Import scores (Excel)' },
    { to: 'remarks', label: 'Remarks' },
    { to: 'class-results', label: 'Class results' },
  ] },
  { key: 'school', section: 'School', icon: MessageSquare, items: [
    { to: 'lesson-notes', label: 'Lesson notes to school' },
    { to: 'messages', label: 'Messages' },
    { to: 'calendar', label: 'Calendar & notices' },
  ] },
  { key: 'me', section: 'Me', icon: UserCircle, items: [
    { to: 'clock-in', label: 'Clock in (scan)' },
    { to: 'my-pay', label: 'My pay' },
    { to: 'notifications', label: 'Notifications' },
    { to: 'account', label: 'Account' },
  ] },
];

/** Older flat list, kept for anything that still imports it. */
export const nav: NavItem[] = teacherGroups.flatMap((g) => g.items.map((i) => ({ to: i.to, label: i.label, icon: g.icon, group: g.section })));
